/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
// Get all the "Add to cart" buttons
const quickAddBtns = document.querySelectorAll('.js-quick-add-to-cart-btn');
const cartIcon = document.querySelector('a.Header__Icon.Icon-Wrapper.Icon-Wrapper--clickable[data-action="open-drawer"]');

// Loop through each button and add the event listener
quickAddBtns.forEach(quickAddBtn => {
  quickAddBtn.addEventListener('click', (event) => {
    event.preventDefault();

    // Get the product ID and variant ID from the data attributes
    const productId = quickAddBtn.getAttribute('data-product-id');
    const variantId = quickAddBtn.getAttribute('data-variant-id');

    // Send an AJAX request to add the product to the cart
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    })
    .then(response => response.json())
    .then(data => {
      // Update the cart count and display a success message
      // You can use Shopify's built-in cart API to update the cart count and display a success message
      console.log("product-added");
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
    bubbles: true
  }));
      if (cartIcon) {
        cartIcon.click();
      }
    })
    .catch(error => {
      console.error('Error:', error);
    });
  });
});

